import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVertical, FileArrowDown } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import ExportModal from './ExportModal/ExportModal'
import * as Styles from './styles'

const MenuCard = ({ cardName, onExport }) => {
  const { t } = useTranslation()
  const [showExportModal, setShowExportModal] = useState(false)

  const onClickInExportOption = () => {
    setShowExportModal(true)
  }

  const options = [
    {
      label: (
        <Styles.MenuOptionLabel>
          <FileArrowDown />
          {t('Exportar datos')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onClickInExportOption,
    },
  ]

  return (
    <>
      <ButtonMenu
        menuItems={options}
        renderButton={onOpen => (
          <IconButton
            onClick={onOpen}
            variant="text"
            icon={<DotsThreeCircleVertical data-testid="menuButton" size={24} />}
          />
        )}
      />
      <ExportModal
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        cardName={cardName}
        onExport={onExport}
      />
    </>
  )
}

export default MenuCard
